import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';

interface PropertiesProps {
  properties?: Record<string, string>;
}

const PropertiesContent = ({ properties }: PropertiesProps) => {
  return properties ? (
    <List disablePadding data-testid="properties-list">
      {Object.entries(properties).map((entry: [string, string]) => {
        return (
          <ListItem key={entry[0]}>
            <ListItemText
              data-testid="properties-list-item-text"
              primaryTypographyProps={{ variant: 'subtitle1' }}
              secondaryTypographyProps={{ variant: 'body2' }}
              primary={entry[0]}
              secondary={entry[1]}
            />
          </ListItem>
        );
      })}
    </List>
  ) : null;
};
export default PropertiesContent;
